// src/components/ColorPicker/Colorpicker.js
import React, { useState } from 'react';
import './ColorPicker.css';

const ColorPicker = ({ colorOptions, selectedColor, onColorChange, productName }) => {
  const [hoveredColor, setHoveredColor] = useState(null);

  // Enhanced color mapping with more variations
  const colorMap = {
    'Orange': '#FF8C42',
    'Red': '#E63946',
    'Blue': '#457B9D',
    'Gray': '#6C757D',
    'Black': '#212529',
    'Brown': '#8B4513',
    'White': '#F8F9FA',
    'Natural Wood': '#DEB887',
    'Dark Brown': '#654321',
    'Beige': '#F5F5DC',
    'Navy Blue': '#000080',
    'Navy': '#000080',
    'Charcoal': '#36454F',
    'Walnut': '#773F1A',
    'Oak': '#BC8F4F',
    'Gold': '#FFD700',
    'Silver': '#C0C0C0',
    'Yellow': '#FFC300',
    'Space Gray': '#3C3C3C',
    'Dark Walnut': '#4A2511',
    'White Oak': '#E5D4B3',
    'Espresso': '#4E342E',
    'Multi': 'linear-gradient(90deg, #E63946, #457B9D, #FFD700)',
    'Terracotta': '#D2691E',
    'Mahogany': '#C04000'
  };

  const handleColorClick = (color) => {
    console.log('Color clicked:', color); // Debug
    onColorChange(color);
  };

  // Ensure colorOptions is an array
  const colors = Array.isArray(colorOptions) ? colorOptions : [colorOptions];

  return (
    <div className="color-picker-container">
      <div className="color-picker-header">
        <span className="color-label">Color:</span>
        <span className="selected-color-name">{selectedColor}</span>
      </div>
      
      <div className="color-options">
        {colors.map((color, index) => (
          <div
            key={index}
            className={`color-swatch ${selectedColor === color ? 'selected' : ''}`}
            style={{
              background: colorMap[color] || color,
              border: selectedColor === color ? '3px solid #667eea' : '2px solid #e5e7eb'
            }}
            onClick={() => handleColorClick(color)}
            onMouseEnter={() => setHoveredColor(color)}
            onMouseLeave={() => setHoveredColor(null)}
            title={color}
          >
            {selectedColor === color && (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" className="check-icon">
                <path 
                  d="M20 6L9 17L4 12" 
                  stroke="white" 
                  strokeWidth="3" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  style={{
                    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))'
                  }}
                />
              </svg>
            )}
          </div>
        ))}
      </div>

      {hoveredColor && (
        <div className="color-tooltip">
          {hoveredColor}
        </div>
      )}
    </div>
  );
};

export default ColorPicker;